import createTheme from '@mui/material/styles/createTheme';
import { ThemeProvider as BaseThemeProvider } from '@emotion/react';
export var theme = createTheme({
    colors: {
        primary: '#0B38DB',
        secondary: '#FF7600',
        tertiary: '#002f86', // Blue for messages
        action: '#0B38DB',
        actionStrong: '#FF7600',
        success: '#dff0d8',
        textDark: '#333',
        textLight: '#fff',
        textGray: '#727272',
        danger: '#a94442',
        borderDanger: '#ee5f5b',
        footerBackground: '#808080',
        backgroundDanger: '#f2dede',
        warning: '#fff4e5',
        info: '#e8f4fd',
        item: '#0000ee',
        tableHeader: '#0B38DB',
    },
    fonts: {
        default: "'Roboto',sans-serif",
        secondary: "'Helvetica Neue', Helvetica,Arial,sans-serif",
        emoji: 'apple color emoji,segoe ui emoji,noto color emoji,android emoji,emojisymbols,emojione mozilla,twemoji mozilla,segoe ui symbol',
    },
});
export var ThemeProvider = function (_a) {
    var children = _a.children;
    return (<BaseThemeProvider theme={theme}>{children}</BaseThemeProvider>);
};
